import React from "react";
import { PropTypes } from "prop-types";
import { withTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";

import history from "components/common/navigation/AppHistory";
import { set_search_text } from "actions/PaginationActions";
import { PROJECTS_ROUTE } from "../../routes/routes";

function ProfileIcons({ actionOnBlock, canBlockUser, showComments, user, t }) {
  const dispatch = useDispatch();
  const { projectSlug } = useParams();

  const gotoComments = () => {
    dispatch(set_search_text(user.uuid, "comments"));
    history.push(`${PROJECTS_ROUTE}/${projectSlug}/comments`);
  };

  return (
    <div className="profile-icons-container">
      {canBlockUser && (
        <>
          {user.block_comments ? (
            <span
              aria-hidden="true"
              className="editor-tooltip editor-tooltip-center"
            >
              <i
                className="material-icons"
                onClick={() => actionOnBlock("unblock")}
              >
                how_to_reg
              </i>
              <span className="editor-tooltiptext">{t("unblockUser")}</span>
            </span>
          ) : (
            <span
              aria-hidden="true"
              className="editor-tooltip editor-tooltip-center"
            >
              <i
                className="material-icons"
                onClick={() => actionOnBlock("block")}
              >
                block
              </i>
              <span className="editor-tooltiptext">{t("blockUser")}</span>
            </span>
          )}
        </>
      )}

      {showComments && !!user.comments && (
        <span
          aria-hidden="true"
          className="editor-tooltip editor-tooltip-center"
        >
          <i className="material-icons" onClick={() => gotoComments()}>
            forum
          </i>
          <span className="editor-tooltiptext">
            {t("gotoComments", { count: user.comments })}
          </span>
        </span>
      )}
    </div>
  );
}

ProfileIcons.propTypes = {
  actionOnBlock: PropTypes.func,
  canBlockUser: PropTypes.bool,
  showComments: PropTypes.bool,
  user: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation("profile")(ProfileIcons);
